<tui-multi-select
  *tuiLet="items$ | async as filtered"
  [class]="componentClass"
  class="b-form"
  [expandable]="false"
  [editable]="false"
  [formControl]="formControl"
  [tuiTextfieldLabelOutside]="labelOutside"
  [tuiTextfieldSize]="size"
  [tuiDropdownLimitWidth]="'min'"
  [stringify]="(stringify$ | async)!"
  [identityMatcher]="identityMatcher"
>
  {{ label }}
  <cdk-virtual-scroll-viewport
    *tuiDataList
    tuiScrollable
    class="scroll"
    [itemSize]="itemSize"
    [style.height.px]="itemHeight$ | async"
  >
    <tui-data-list tuiMultiSelectGroup>
      <button
        class="whitespace-nowrap overflow-hidden"
        *cdkVirtualFor="let item of filtered"
        tuiOption
        [value]="item[itemValue]"
      >
        {{ item[itemText] }}
      </button>
    </tui-data-list>
  </cdk-virtual-scroll-viewport>
</tui-multi-select>
